import React from "react";
import { Link, withRouter } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

import { Auth } from "aws-amplify";

import styles from "./Navbar.module.scss";

import avatarSmall from "../../assets/images/avatar-small.svg";
import { ReactComponent as BillingIcon } from "../../assets/images/navbar/dollar-sign.svg";
import { ReactComponent as DashboardIcon } from "../../assets/images/navbar/dashboard.svg";
import { ReactComponent as FAQIcon } from "../../assets/images/navbar/faq.svg";
import { ReactComponent as LogoutIcon } from "../../assets/images/navbar/logout.svg";
import { ReactComponent as NotificationIcon } from "../../assets/images/navbar/notification.svg";
import { ReactComponent as PaymentIcon } from "../../assets/images/navbar/earnings.svg";
import { ReactComponent as ProfileIcon } from "../../assets/images/navbar/profile.svg";
const MAGIC_LOGO_URL =
  "https://magic-public-images.s3.ap-northeast-1.amazonaws.com/icons/Magic-Logo-2022.svg";

export function Navbar({ client, disabled, hasUser, history }) {
  const activeClassName = (pathname) =>
    `${history.location.pathname}${history.location.hash}` === pathname ? styles.active : "";

  const signOut = async (e) => {
    e.preventDefault();

    try {
      await Auth.signOut();
    } catch (error) {
      console.log("error signing out: ", error);
    }
  };

  return (
    <nav
      className={`navbar navbar-light navbar-expand-lg ${styles.navbarCustom}`}
      data-testid="navbar"
    >
      <Link className={`navbar-brand ${styles.navbarBrand} d-flex align-items-center`} to="/">
        <img src={MAGIC_LOGO_URL} alt="Magic Logo" />
        <div className="mr-2" />
        <span className={styles.logoText}> Magic</span>
        <div className="mr-2" />
        <span className={`${styles.logoTextDedicated} d-none d-xl-inline-block d-lg-inline-block`}>
          {" "}
          Dedicated
        </span>
      </Link>
      {hasUser && (
        <button
          className={`navbar-toggler ${styles.navbarToggle}`}
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <img
            className={styles.avatar}
            src={(client.profile || {}).photo_url || avatarSmall}
            alt=""
          />
        </button>
      )}
      {hasUser && (
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <div className="ml-auto">
            <ul className="navbar-nav ml-auto">
              <li className="nav-item dropdown d-none d-xl-block d-lg-block">
                <div
                  className={`nav-link dropdown-toggle d-flex align-items-center ${styles.dropdownToggle}`}
                  id="navbarDropdownMenuLink"
                  data-toggle="dropdown"
                  aria-expanded="false"
                >
                  <img
                    className={styles.avatar}
                    src={(client.profile || {}).photo_url || avatarSmall}
                    alt=""
                  />
                </div>
              </li>
              {!disabled ? (
                <>
                  <li className="nav-item dropdown mt-3 d-block d-xl-none d-lg-none">
                    <Link
                      className={`dropdown-item d-flex align-items-center ${
                        styles.dropdownItem
                      } ${activeClassName("/")}`}
                      to="/"
                    >
                      <DashboardIcon className={`mr-3 ${styles.fill}`} />
                      <span>Dashboard</span>
                    </Link>
                  </li>
                  <li className="nav-item dropdown d-block d-xl-none d-lg-none">
                    <HashLink
                      className={`dropdown-item d-flex align-items-center ${
                        styles.dropdownItem
                      } ${activeClassName("/#billing")}`}
                      to="/#billing"
                    >
                      <BillingIcon className={`mr-3 ${styles.stroke}`} />
                      <span>Billing</span>
                    </HashLink>
                  </li>
                  <li className="nav-item dropdown d-block d-xl-none d-lg-none">
                    <Link
                      className={`dropdown-item d-flex align-items-center ${
                        styles.dropdownItem
                      } ${activeClassName("/payment-info")}`}
                      to="/payment-info"
                    >
                      <PaymentIcon className={`mr-3 ${styles.fill}`} />
                      <span>Payment Info</span>
                    </Link>
                  </li>
                  <li className="nav-item dropdown d-block d-xl-none d-lg-none">
                    <Link
                      className={`dropdown-item d-flex align-items-center ${
                        styles.dropdownItem
                      } ${activeClassName("/profile/settings/account")}`}
                      to="/profile/settings/account"
                    >
                      <DashboardIcon className={`mr-3 ${styles.fill}`} />
                      <span>Account Settings</span>
                    </Link>
                  </li>
                  <li className="nav-item dropdown d-block d-xl-none d-lg-none">
                    <Link
                      className={`dropdown-item d-flex align-items-center ${
                        styles.dropdownItem
                      } ${activeClassName("/profile/edit")}`}
                      to="/profile/edit"
                    >
                      <ProfileIcon className={`mr-3 ${styles.fill}`} />
                      <span>Profile</span>
                    </Link>
                  </li>
                  <li className="nav-item dropdown d-block d-xl-none d-lg-none">
                    <Link
                      className={`dropdown-item d-flex align-items-center ${
                        styles.dropdownItem
                      } ${activeClassName("/profile/settings/notifications")}`}
                      to="/profile/settings/notifications"
                    >
                      <NotificationIcon className={`mr-3 ${styles.fill}`} />
                      <span>Notifications</span>
                    </Link>
                  </li>
                </>
              ) : null}
              <li className="nav-item dropdown d-block d-xl-none d-lg-none">
                <a
                  className={`dropdown-item d-flex align-items-center ${styles.dropdownItem}`}
                  href="mailto:client@getmagicnow.com?subject=Support%20Dedicated%20Assistant"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FAQIcon className={`mr-3 ${styles.stroke}`} />
                  <span>Support / FAQ</span>
                </a>
              </li>
              <li className="nav-item dropdown d-block d-xl-none d-lg-none">
                <a
                  className={`dropdown-item d-flex align-items-center ${styles.dropdownItem}`}
                  href="/"
                  onClick={signOut}
                >
                  <LogoutIcon className={`mr-3 ${styles.stroke}`} />
                  <span>Logout</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      )}
    </nav>
  );
}

export default withRouter(Navbar);
